import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  Image,
  StyleSheet,
  Link
} from "@react-pdf/renderer";
import parse from "html-react-parser";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { formatDate } from "../../../helpers/dateHelper";

import hotelImg from "../../../assets/images/hotels/hotelsmall.png";
import NohotelImg from "../../../assets/images/hotels/no_img.png";
import LogoImg from "../../../assets/images/logos/trip-logo.png";

dayjs.extend(customParseFormat);
const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    padding: 20,
  },
  section: {
    padding: "0 10px",
  },
  innerSection: {
    position: "relative",
    paddingLeft: 30,
  },
  borderleft: {
    position: "absolute",
    width: 3,
    height: "100%",
    backgroundColor: "#e9ecef",
  },
  tourContentColumn: {
    position: "relative",
    paddingLeft: 50,
    marginTop: 4,
  },
  borderleftFull: {
    position: "absolute",
    left: 0,
    top: 0,
    bottom: 0,
    width: 3,
    backgroundColor: "#e9ecef",
  },
  heading: {
    fontSize: 14,
    marginBottom: 10,
    color: "#274581",
  },
  title: {
    fontSize: 12,
    marginBottom: 4,
    color: "#274581",
  },
  subtitle: {
    fontSize: 10,
    marginBottom: 8,
  },
  stitle: {
    fontSize: 10,
  },
  textDanger: {
    color: "#dc3545",
  },

  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 5,
    flexWrap: "wrap",
    alignItems: "center", // Vertically center items
    borderBottomWidth: 1, // Optional, to create a line under each row
    borderBottomColor: "#ddd", // Light gray color for border
  },

  wHalf: {
    width: "50%",
    marginBottom: 5,
  },
  card: {
    position: "relative",
    padding: 10,
    border: "1px solid #e9ecef",
    borderRadius: 2,
    width: 500,
    maxWidth: "100%",
  },
  hotelimgWrapper: {
    width: 100,
  },
  hotelLogo: {
    width: 10,
  },
  tourImg: {
    width: 100,
  },
  mb10: {
    marginBottom: 10,
  },
  contentWrapper: {
    position: "relative",
    marginBottom: 10,
  },

  typeTitle: {
    backgroundColor: "#1e4167",
    width: 40,
    padding: "4px 5px",
    fontSize: 12,
    textAlign: "left",
    borderRadius: 4,
    color: "#fff",
    marginLeft: -50,
    marginBottom: 10,
  },

  timelineBadge: {
    position: "absolute",
    top: 9,
    left: -46,
    zIndex: 10,
    width: 35,
    height: 35,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // borderRadius: "50%", // @react-pdf/renderer does not support percentage; use numeric for circle (half of width/height) - idea from ActivitiesDoc
    borderRadius: 18,
    textAlign: "center",
    fontSize: 9,
    color: "#fff",
    backgroundColor: "#ffbc34",
  },
  description:
  {
    width: '100%',
    fontSize: 10,
    marginBottom: 8,
    fontSize: 12,
    marginTop: 2,
    color: '#0c5460',
    backgroundColor: '#d1ecf1',
    padding: 10,
    border: '1px solid rgb(172, 210, 217)',
    borderRadius: 2,
  },
  // Match ActivitiesDoc.js: white background, same padding - do not change background color
  headerWrraper: {
    backgroundColor: "#ffffff",
    paddingVertical: 5,
    paddingHorizontal: 15,
  },
  mb_5: { marginBottom: 5 },
  detailsSectionBlock: {
    backgroundColor: "#EAF2FA",
    borderRadius: 6,
  },
  hotelsPackageDetails: { width: 350, paddingLeft: 10 },
  addressDetails: {
    textAlign: "right",
    fontSize: 10,
    paddingBottom: 5,
    paddingRight: 10,
    paddingLeft: 10,
  },
  addressText: {
    fontSize: 10,
    textAlign: "right",
    lineHeight: 1.2,
    width: "100%",
  },
  addressBox: {
    borderWidth: 1,
    borderColor: "#E0E0E0",
    padding: 4,
    width: "50%",
  },
  flex5: {
    flex: 0.49,
  },
  logoSection: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    flexWrap: "wrap",
  },
  textRight: {
    textAlign: "cen",
  },
  alignSelf: {
    alignSelf: "flex-end",
    marginBottom: 6,
  },
  justifyContentBetween: {
    justifyContent: "space-between",
  },
  verticalLine: {
    position: "absolute", // Position the line between cells
    left: "50%", // Center the line between the two columns
    top: -1,
    bottom: 0,
    width: 1, // The thickness of the vertical line
    backgroundColor: "#ddd", // Color of the vertical line
    height: "100%", // Full height of the row
    alignSelf: "stretch", // Ensures the line stretches to the container's height
  },
  container: {
    // borderWidth: 1, // Add border to the container to simulate table border
    borderColor: "#ddd", // Light color for the border
  },
  leftCell: {
    flex: 1,
    fontSize: 10,
    textAlign: "left", // Left-align the labels
    paddingLeft: 10,
    paddingVertical: 3,
  },

  rightCell: {
    flex: 1,
    fontSize: 10,
    textAlign: "right", // Right-align the values
    paddingRight: 10,
    // marginLeft: 300,
    paddingVertical: 3,
  },
  // Important Note page (from ActivitiesDoc.js)
  description1: {
    width: "100%",
    fontSize: 10,
    marginBottom: 10,
    color: "#0c5460",
    backgroundColor: "#d0e3e7",
    padding: 10,
  },
  note: {
    fontSize: 10,
    marginTop: 2,
    marginBottom: 2,
    lineHeight: 1.5,
    color: "#0c5460",
    textAlign: "justify",
    flexDirection: "row",
  },
  bullet: {
    fontWeight: "bold",
  },
  title1: {
    fontSize: 12,
    marginTop: 8,
    textAlign: "center",
    color: "#000",
    fontWeight: "bold",
  },
  row1: {
    marginTop: 6,
    marginBottom: 5,
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    borderTopWidth: 0,
    borderColor: "#000",
    alignItems: "center",
  },
  headerCell: {
    fontWeight: "bold",
    backgroundColor: "#e0f0f5",
    color: "#000",
    fontSize: 15,
  },
  cell: {
    fontSize: 10,
    padding: 2,
    borderRightWidth: 1,
    borderColor: "#000",
    flex: 1,
    borderRightColor: "#000",
    textAlign: "center",
  },
  lastCell: {
    borderRightWidth: 0,
  },
  tableSection: {
    marginTop: 10,
  },
});

// const Description = ({ tourShortDescription }) => {
//   let returnContentConst = <Text style={{ display: "inline" }}>{""}</Text>;
//   if (tourShortDescription) {
//     const parsedHtml = parse(tourShortDescription);
//     parsedHtml.forEach((element) => {
//       if (element?.props && element?.props?.children) {
//         element.props.children.forEach((content) => {
//           returnContentConst = (
//             <Text style={{ display: "inline" }}>{content}</Text>
//           );
//         });
//       } else {
//         if (element)
//           returnContentConst = (
//             <Text style={{ display: "inline" }}>{element}</Text>
//           );
//       }
//     });
//     return returnContentConst;
//   } else {
//     return returnContentConst;
//   }
// };

const Description = ({ tourShortDescription }) => {
  let returnContentConst = <Text style={{ display: "inline" }}>{""}</Text>;

  if (tourShortDescription) {
    const parsedHtml = parse(tourShortDescription);
    const combinedContent = []; // Store all the content

    parsedHtml.forEach((element) => {
      if (element?.props && element?.props?.children) {
        element.props.children.forEach((content) => {
          if (typeof content === "string") {
            combinedContent.push(content); // Add text content to the array
          } else {
            // If it's a nested element, push it as it is
            combinedContent.push(content);
          }
        });
      } else {
        if (typeof element === "string") {
          combinedContent.push(element); // Add text directly to the array
        } else {
          // If it's an element, push it
          combinedContent.push(element);
        }
      }
    });

    // Combine everything in the array into a single <Text> component
    returnContentConst = <Text style={{ display: "inline", flexWrap: "wrap" }}>{combinedContent}</Text>;
  }

  return returnContentConst;
};


const HotelImg = ({ img }) => {
  if (img) {
    return (
      <View style={styles.hotelimgWrapper}>
        <Image style={{ width: "100%" }} src={img} />
      </View>
    );
  } else {
    return (
      <View style={styles.hotelimgWrapper}>
        <Image style={{ width: "100%" }} src={NohotelImg} />
      </View>
    );
  }
};

const getHotelPaxCount = (roomsArray) => {
  if (roomsArray.length > 0) {
    let pax = roomsArray[0];
    return `Adult(s) ${pax?.AdultCount !== "0" ? pax?.AdultCount : 0} ${pax?.ChildCount !== "0" ? ", Child(s) " + pax?.ChildCount : " "
      } `;
  }
};

const getPaxCount = (pax) => {
  return `Adult(s) ${pax?.adult !== "0" ? pax?.adult : 0} ${pax?.child !== "0" ? ", Child(s) " + pax?.child : " "
    } ${pax?.infant !== "0" ? ", Infant(s) " + pax?.infant : " "}`;
};
const BASE = process.env.REACT_APP_BASE_URL;
const BuildPackageDoc = ({
  ticketData,
  agent,
  showPrice = true,
  withFare,
  Logo,
  activeCurrency,
  currencyValue = () => { },
}) => {
  // Same as ActivitiesDoc: guard against null/undefined ticketData so PDF render never throws (reading 'props' of null)
  if (!ticketData || typeof ticketData !== "object" || Object.keys(ticketData).length === 0) {
    return (
      <Document>
        <Page size="A4" style={styles.page}>
          <View style={styles.section}>
            <Text>No ticket data available.</Text>
          </View>
        </Page>
      </Document>
    );
  }

  const getStatus = (status) => {
    switch (status) {
      case 0: {
        return <Text style={{ color: "#FF0000" }}>CANCELLED</Text>;
      }
      case 1: {
        return <Text style={{ color: "#FF0000" }}>ALREADY CANCELLED</Text>;
      }
      case 2: {
        return <Text style={{ color: "#FFA500" }}>BLOCKED </Text>;
      }
      case 3: {
        return <Text style={{ color: "#008000" }}>CONFIRMED</Text>;
      }
      case 7: {
        return <Text style={{ color: "#FF0000" }}>On Request</Text>;
      }
      case 11: {
        return <Text style={{ color: "#FF0000" }}>VOUCHERED</Text>;
      }
      default:
        return <Text style={{ fontSize: 10 }}>-</Text>;
    }
  };

  const getTimebyUser = (optionData) => {
    if (!optionData?.optionName) return false;
    if (
      optionData.optionName.includes("Airport") ||
      (optionData.optionName.includes("Transfer") &&
        optionData.transferName === "Private Transfers")
    ) {
      return true;
    }
    return false;
  };

  // Flatten tour details for one-ticket-per-page (like ActivitiesDoc.js)
  const flattenTourDetails = () => {
    const list = [];
    if (!ticketData?.tourDetails?.length) return list;
    ticketData.tourDetails.forEach((tourList, dayIndex) => {
      if (tourList && tourList.length) {
        tourList.forEach((tour) => {
          if (tour && typeof tour === "object") list.push({ tour, dayIndex });
        });
      }
    });
    return list;
  };

  const renderTourCard = (tour, dayIndex) => {
    if (!tour || typeof tour !== "object") {
      return (
        <View key={`empty-${dayIndex}`} style={styles.contentWrapper}>
          <Text> </Text>
        </View>
      );
    }
    return (
    <View key={`${dayIndex}-${tour?.BookingRefNo}`} style={styles.contentWrapper}>
      <View style={styles.timelineBadge}>
        <Text>Day {dayIndex + 1}</Text>
      </View>
      <View style={styles.card}>
        <Text style={styles.title}>{tour.tourName}</Text>
        <Text style={styles.subtitle}>{tour.optionName}</Text>
        {!agent ? (
          <Text style={styles.subtitle}>
            Provider Reference No : {tour?.ProviderRefNo}
          </Text>
        ) : null}
        <View style={styles.row}>
          <Image
            style={[styles.tourImg, { marginBottom: "4px" }]}
            src={tour?.tourImage && typeof tour.tourImage === "string" ? tour.tourImage : NohotelImg}
          />
        </View>
        {!(
          tour.tourId?.startsWith("EXT") ||
          tour.tourId?.startsWith("Ext")
        ) &&
          tour.transferName !== "Private Transfers" && (
            <View style={styles.description}>
              <Description
                tourShortDescription={tour.tourShortDescription}
              />
            </View>
          )}
        <View style={styles.container}>
          <View style={styles.row}>
            <Text style={styles.leftCell}>Booking Status :</Text>
            <View style={styles.verticalLine} />
            <Text style={styles.rightCell}>
              {getStatus(
                (() => {
                  const isExt = tour?.tourId?.startsWith("EXT") || tour?.tourId?.startsWith("Ext");
                  const apiStatus = tour?.BookingStatus ?? tour?.bookingStatus;
                  if (isExt) return 3;
                  if (apiStatus === 7 && tour?.ticket?.length > 0) return 11;
                  return apiStatus;
                })()
              )}
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.leftCell}> Booking ID:</Text>
            <View style={styles.verticalLine} />
            <Text style={styles.rightCell}> {tour?.BookingRefNo}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.leftCell}> Travel Date :</Text>
            <View style={styles.verticalLine} />
            <Text style={styles.rightCell}>
              {formatDate(tour.tourDate, "DD-MM-YYYY")}
            </Text>
          </View>
          {(tour.tourId?.startsWith("EXT") ||
            tour.tourId?.startsWith("Ext")) ? (
            <View style={styles.row}>
              <Text style={styles.leftCell}>Last Vouchered Date :</Text>
              <View style={styles.verticalLine} />
              <Text style={styles.rightCell}>
                {formatDate(
                  dayjs(tour.tourDate, "YYYY-MM-DD").subtract(4, "days"),
                  "ddd DD MMM YYYY"
                )}
              </Text>
            </View>
          ) : null}
          <View style={styles.row}>
            <Text style={styles.leftCell}> Transfer Option :</Text>
            <View style={styles.verticalLine} />
            <Text style={styles.rightCell}>{tour.transferName}</Text>
          </View>
          {!getTimebyUser(tour) && tour.duration && (
            <View style={styles.row}>
              <Text style={styles.leftCell}>Duration :</Text>
              <View style={styles.verticalLine} />
              <Text style={styles.rightCell}>{tour.duration}</Text>
            </View>
          )}
          {tour?.ticket?.length > 0 &&
          tour?.ticket.some((ticket) => ticket?.timeSlot) ? (
            <View style={styles.row}>
              <Text style={styles.leftCell}>Slot:</Text>
              <View style={styles.verticalLine} />
              <Text style={styles.rightCell}>
                {tour?.ticket
                  .filter((ticket) => ticket?.timeSlot)
                  .map((ticket) => ticket.timeSlot)
                  .join(", ")}
              </Text>
            </View>
          ) : (
            <View style={styles.row}>
              <Text style={styles.leftCell}>
                {tour.transferName === "Private Transfers"
                  ? "Pickup time"
                  : "Start Time"}
              </Text>
              <View style={styles.verticalLine} />
              <Text style={styles.rightCell}>
                {tour ? tour?.startTime : "Time Not Available"}
              </Text>
            </View>
          )}
          {tour.pickup !== "" && (
            <View style={styles.row}>
              <Text style={styles.leftCell}>
                {tour.tourName.includes("Pick Up")
                  ? "Drop Off Location"
                  : "Pick Up Location"}
              </Text>
              <View style={styles.verticalLine} />
              <Text style={styles.rightCell}>{tour.pickup}</Text>
            </View>
          )}
          <View style={styles.row}>
            <Text style={styles.leftCell}>Number of Passengers :</Text>
            <View style={styles.verticalLine} />
            <Text style={styles.rightCell}>{getPaxCount(tour)}</Text>
          </View>
          {withFare ? (
            <View style={styles.row}>
              {showPrice && (
                <Text style={styles.leftCell}>Amount :</Text>
              )}
              {showPrice && <View style={styles.verticalLine} />}
              <Text style={styles.rightCell}>INR {tour.serviceTotal}</Text>
            </View>
          ) : null}
        </View>
      </View>
    </View>
    );
  };

  const createTourPage = (item, includeHeader) => (
    <Page key={`tour-page-${item.dayIndex}-${item.tour?.BookingRefNo}`} size="A4" style={styles.page} wrap={true}>
      <View style={styles.section}>
        {includeHeader && (
          <>
            <View style={styles.logoSection}>
              <View style={{ ...styles.flex5 }}>
                    {Logo && typeof Logo === "string" ? (
                      <Image
                        src={BASE + Logo.substring(1)}
                        style={{ height: 50, width: 100, marginBottom: 10 }}
                      />
                    ) : (
                      <Image style={{ width: 100, heigh: 50 }} src={LogoImg} />
                    )}
              </View>
              <View
                style={{
                  ...styles.addressDetails,
                  ...styles.addressBox,
                  width: "50%",
                }}
              >
                {ticketData?.agentDetails ? (
                  <Text style={styles.addressText}>
                    {ticketData?.agentDetails?.AgencyName}
                    {"\n"}
                    {ticketData?.agentDetails?.Address1}{" "}
                    {ticketData?.agentDetails?.Address2}
                    {"\n"}
                    {ticketData?.agentDetails?.City}{" "}
                    {ticketData?.agentDetails?.State}
                    {" "}
                    Email: {ticketData?.agentDetails?.Email}
                    {"\n"}
                    {ticketData?.agentDetails?.Phone
                      ? `Contact No.: ${ticketData?.agentDetails?.Phone}`
                      : ""}
                  </Text>
                ) : ticketData?.adminDetails?.length > 0 ? (
                  <Text style={styles.addressText}>
                    {ticketData?.adminDetails[0]?.Address}
                    {"\n"}
                    {ticketData?.adminDetails[0]?.CityName}{" "}
                    {ticketData?.adminDetails[0]?.StateName}
                    {"\n"}
                    {ticketData?.adminDetails[0]?.CountryName}{" "}
                    {ticketData?.adminDetails[0]?.PostalCode}
                  </Text>
                ) : null}
              </View>
            </View>
            <View
              style={[
                styles.headerWrraper,
                styles.detailsSectionBlock,
                { marginTop: 10 },
              ]}
            >
              <Text style={styles.title}>Passenger Details</Text>
              <View style={styles.row}>
                <Text style={{ ...styles.subtitle, ...styles.wHalf }}>
                  Guest Name: {ticketData?.leadPassenger?.firstName}{" "}
                  {ticketData?.leadPassenger?.lastName}
                </Text>
                <Text style={{ ...styles.subtitle, ...styles.wHalf }}>
                  Email: {ticketData?.leadPassenger?.email}
                </Text>
                <Text style={{ ...styles.subtitle, ...styles.wHalf }}>
                  Contact: {ticketData?.leadPassenger?.mobile}
                </Text>
              </View>
            </View>
            <View
              style={[
                styles.headerWrraper,
                styles.mb_5,
                styles.detailsSectionBlock,
              ]}
            >
              <Text style={styles.title}>Payment Details</Text>
              <View style={styles.row}>
                <Text style={{ ...styles.subtitle, ...styles.wHalf }}>
                  Confirmation No: {ticketData?.bookingRefNo}
                </Text>
                {!agent && (
                  <Text style={{ ...styles.subtitle, ...styles.wHalf }}>
                    Provider Ref No: {ticketData?.ProviderRefNo}
                  </Text>
                )}
                <Text style={{ ...styles.subtitle, ...styles.wHalf }}>
                  Payment Mode:{" "}
                  {ticketData?.partPayment?.isPartPayment === true
                    ? "Part"
                    : "Full"}{" "}
                  Payment
                </Text>
                {withFare && (
                  <>
                    <Text style={{ ...styles.subtitle, ...styles.wHalf }}>
                      Total Fare: {ticketData?.partPayment?.serviceTotal}
                    </Text>
                    {ticketData?.partPayment?.isPartPayment === true ? (
                      <>
                        <Text
                          style={{ ...styles.subtitle, ...styles.wHalf }}
                        >
                          Paid Amount:{" "}
                          {ticketData?.partPayment?.partPaymentAmount}
                        </Text>
                        <Text
                          style={{
                            ...styles.subtitle,
                            ...styles.wHalf,
                            ...styles.textDanger,
                          }}
                        >
                          Due Amount: {ticketData?.partPayment?.dueAmount}
                        </Text>
                        <Text
                          style={{
                            ...styles.subtitle,
                            ...styles.wHalf,
                            ...styles.textDanger,
                          }}
                        >
                          Last Date:{" "}
                          {ticketData?.partPayment?.PaymentDueDate}
                        </Text>
                      </>
                    ) : null}
                  </>
                )}
              </View>
            </View>
            <View />
            <Text style={styles.heading}> DAY WISE ITINERARY - TOUR</Text>
          </>
        )}
        <View style={styles.tourContentColumn}>
          <View style={styles.borderleftFull} />
          {includeHeader && (
            <View style={styles.innerSection}>
              <Text style={styles.typeTitle}>Tours</Text>
            </View>
          )}
          {renderTourCard(item.tour, item.dayIndex)}
        </View>
      </View>
    </Page>
  );

  // Important Note page on last page of every ticket (from ActivitiesDoc.js)
  const contactData = [
    ["India", "+91 11 49511313", "Sonal & Bulbul", "9811906582, 9811294417"],
    ["Dubai", "+91 11 49511313", "Sonal & Bulbul", "9811906582, 9811294417"],
    ["Baku", "+91 11 49511313", "Sonal & Bulbul", "9811906582, 9811294417"],
    ["USA", "+91 11 49511313", "Rahul Parmar", "8130993954, +1(559)547-9778"],
    [
      "Europe",
      "+91 11 49511313",
      "Rahul Parmar",
      "8130993954, +39-37154-04210",
    ],
    ["Turkey", "+91 11 49511313", "Bulbul", "9811294417"],
    ["Bali", "+91 11 49511313", "Sonal", "9811906582"],
    ["Singapore", "+91 11 49511313", "Sonal", "9811906582"],
    [
      "Japan",
      "+91 11 49511313",
      "Rahul Parmar & Bulbul",
      "8130993954, 9811294417",
    ],
    [
      "Australia",
      "+91 11 49511313",
      "Rahul Parmar",
      "8130993954, +61-43137-3179",
    ],
    ["New Zealand", "+91 11 49511313", "Rahul Parmar", "8130993954"],
  ];

  const getImportantNote = () => (
    <Page size="A4" style={styles.page}>
      <View style={styles.section}>
        <View style={styles.description1}>
          <Text style={styles.title}>Important Note:</Text>
          <Text style={styles.note}>
            <Text style={styles.bullet}>1. </Text>
            In the event of a vehicle breakdown or tyre puncture during a
            transfer, you are required to wait until the issue is resolved by
            the driver.
          </Text>
          <Text style={styles.note}>
            <Text style={styles.bullet}>2. </Text>
            In Europe, drivers are not obligated to assist with loading or
            unloading luggage into the vehicle.
          </Text>
          <Text style={styles.note}>
            <Text style={styles.bullet}>3. </Text>
            For airport pickups, ensure you're picked up within one hour of
            landing. Delays are subject to the driver's availability. Contact
            the emergency number.
          </Text>
          <Text style={styles.note}>
            <Text style={styles.bullet}>4. </Text>
            If a guest spills food or drink inside the vehicle, they must clean
            it or pay a fine to the driver.
          </Text>

          <View style={styles.tableSection}>
            <Text style={styles.title1}>
              Emergency Contact details according to destination - All Time in
              IST
            </Text>
            <View style={[styles.row1, styles.headerCell]}>
              <Text style={styles.cell}>Country</Text>
              <Text style={styles.cell}>Time (10:00 to 06:00 PM)</Text>
              <Text style={styles.cell}>Staff Name</Text>
              <Text style={[styles.cell, styles.lastCell]}>
                Staff Number After (06:00 PM)
              </Text>
            </View>
            {contactData.map(([country, time, staff, number], index) => (
              <View style={styles.row1} key={index}>
                <Text style={styles.cell}>{country}</Text>
                <Text style={styles.cell}>{time}</Text>
                <Text style={styles.cell}>{staff}</Text>
                <Text style={[styles.cell, styles.lastCell]}>{number}</Text>
              </View>
            ))}
          </View>
        </View>
      </View>
    </Page>
  );

  // Build document children without null (react-pdf throws "reading 'props' of null" when Document has null children)
  const documentChildren = [
    ticketData.hotelsPackageDetails?.length ? (
            <Page size="A4" style={styles.page}>
              <View style={styles.section}>
                <View style={styles.logoSection}>
                  <View style={{ ...styles.flex5 }}>
                    {Logo && typeof Logo === "string" ? (
                      <Image
                        src={BASE + Logo.substring(1)}
                        style={{ height: 50, width: 100, marginBottom: 10 }}
                      />
                    ) : (
                      <Image style={{ width: 100, heigh: 50 }} src={LogoImg} />
                    )}
                  </View>
                  <View style={{ ...styles.flex5, ...styles.addressDetails }}>
                    {ticketData?.agentDetails ? (
                      <View style={{ ...styles.textRight, ...styles.justifyContentBetween }}>
                        <Text style={{ ...styles.alignSelf }}>{ticketData?.agentDetails?.AgencyName}{" "}</Text>
                        <Text style={{ ...styles.alignSelf }}>{ticketData?.agentDetails?.Address1}{" "}{ticketData?.agentDetails?.Address2}</Text>
                        {ticketData?.agentDetails?.City || ticketData?.agentDetails?.State ? (
                          <Text style={{ ...styles.alignSelf }}>{ticketData?.agentDetails?.City}{" "}{ticketData?.agentDetails?.State}</Text>
                        ) : null}
                        <Text style={{ ...styles.alignSelf }}>Email: {ticketData?.agentDetails?.Email}</Text>
                        {ticketData?.agentDetails?.Phone ? (
                          <Text style={{ ...styles.alignSelf }}>Contact No.: {ticketData?.agentDetails?.Phone}</Text>
                        ) : null}
                      </View>
                    ) : ticketData?.adminDetails?.length > 0 ? (
                      <View style={{ ...styles.textRight, ...styles.justifyContentBetween }}>
                        <Text style={{ ...styles.alignSelf }}>{ticketData?.adminDetails[0]?.Address}{" "}</Text>
                        <Text style={{ ...styles.alignSelf }}>{ticketData?.adminDetails[0]?.CityName}{" "}{ticketData?.adminDetails[0]?.StateName}</Text>
                        <Text style={{ ...styles.alignSelf }}>{ticketData?.adminDetails[0]?.CountryName}{" "}{ticketData?.adminDetails[0]?.PostalCode}</Text>
                      </View>
                    ) : null}
                  </View>
                </View>

                <Text style={styles.heading}> INCLUSIONS DETAILS - HOTEL </Text>
                <View style={styles.innerSection}>
                  <View style={styles.borderleft}></View>

                  {ticketData.hotelsPackageDetails?.length > 0 ? (
                    <Text style={styles.typeTitle}>Hotel</Text>
                  ) : null}
                  {ticketData.hotelsPackageDetails.length > 0
                    ? ticketData.hotelsPackageDetails.map((hotel, index) => {
                      return (
                        <View
                          key={index + "hotel"}
                          style={styles.contentWrapper}
                        >
                          <View style={styles.timelineBadge}>
                            {hotel?.hotelImage ? (
                              <Image
                                src={hotel?.hotelImage}
                                source={{
                                  header: {
                                    "Access-Control-Allow-Origin": "*",
                                  },
                                }}
                              />
                            ) : (
                              <Image
                                style={styles.hotelLogo}
                                src={hotelImg}
                              />
                            )}
                          </View>

                          <View key={index} style={styles.card}>
                            <View
                              style={{
                                ...styles.row,
                              }}
                            >
                              <HotelImg img={hotel.hotelImage} />
                              <View style={styles.hotelsPackageDetails}>
                                <Text style={styles.title}>
                                  {hotel.HotelName}
                                </Text>
                                <View style={styles.row}>
                                  <Text
                                    style={{
                                      ...styles.stitle,
                                      ...styles.wHalf,
                                    }}
                                  >
                                    Check in Date :
                                  </Text>
                                  <Text
                                    style={{
                                      ...styles.stitle,
                                      ...styles.wHalf,
                                    }}
                                  >
                                    {formatDate(hotel.CheckInDate, "DD-MM-YYYY")}
                                  </Text>
                                  <Text
                                    style={{
                                      ...styles.stitle,
                                      ...styles.wHalf,
                                    }}
                                  >
                                    Check Out Date :
                                  </Text>
                                  <Text
                                    style={{
                                      ...styles.stitle,
                                      ...styles.wHalf,
                                    }}
                                  >
                                    {formatDate(hotel.CheckOutDate, "DD-MM-YYYY")}
                                  </Text>
                                  <Text
                                    style={{
                                      ...styles.stitle,
                                      ...styles.wHalf,
                                    }}
                                  >
                                    Room Type :
                                  </Text>
                                  <Text
                                    style={{
                                      ...styles.stitle,
                                      ...styles.wHalf,
                                    }}
                                  >
                                    {hotel.Rooms[0].RoomName}
                                  </Text>
                                  <Text
                                    style={{
                                      ...styles.stitle,
                                      ...styles.wHalf,
                                    }}
                                  >
                                    No. of Pax :
                                  </Text>
                                  <Text
                                    style={{
                                      ...styles.stitle,
                                      ...styles.wHalf,
                                    }}
                                  >
                                    {getHotelPaxCount(hotel.Rooms)}
                                  </Text>

                                  <Text
                                    style={{
                                      ...styles.stitle,
                                      ...styles.wHalf,
                                    }}
                                  >
                                    No. of Nights :
                                  </Text>
                                  <Text
                                    style={{
                                      ...styles.stitle,
                                      ...styles.wHalf,
                                    }}
                                  >
                                    {hotel.Rooms[0].noOfNight}
                                  </Text>
                                  {withFare ? (
                                    <>
                                      {showPrice && (
                                        <Text
                                          style={{
                                            ...styles.stitle,
                                            ...styles.wHalf,
                                          }}
                                        >
                                          Amount :
                                        </Text>
                                      )}
                                      {showPrice && (
                                        <Text
                                          style={{
                                            ...styles.stitle,
                                            ...styles.wHalf,
                                          }}
                                        >
                                          INR {hotel.Rooms[0].pricePerRoom}
                                        </Text>
                                      )}
                                    </>
                                  ) : null}
                                </View>
                              </View>
                            </View>
                          </View>
                        </View>
                      );
                    })
                    : null}
                </View>
              </View>
            </Page>
          ) : null,
    ...(ticketData?.tourDetails?.length
      ? flattenTourDetails().map((item, i) =>
          createTourPage(item, i === 0)
        )
      : []),
    getImportantNote()
  ].filter(Boolean);

  return (
    <Document>
      {documentChildren}
    </Document>
  );
};


export default BuildPackageDoc;